import { ShieldCheck, TriangleAlert } from "lucide-react";
export default function OurTrustCommitment() {
  return <section data-section-id="262742" id="our-trust-commitment" className="w-full flex flex-col bg-background text-foreground">
      {}
      <div className="w-full bg-background border-y border-border py-4 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
          <div className="bg-muted p-2 rounded-lg shrink-0">
            <ShieldCheck className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h3 className="font-default text-sm font-bold uppercase tracking-widest text-primary">
              Trusted Reviews
            </h3>
            <p className="font-sans text-sm text-muted-foreground mt-0.5">
              Unbiased, hands-on evaluations from home security experts you can rely on.
            </p>
          </div>
        </div>
      </div>

      {}
      <div className="w-full bg-card border-b border-border py-4 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
          <div className="bg-muted p-2 rounded-lg shrink-0">
            <TriangleAlert className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h3 className="font-default text-sm font-bold uppercase tracking-widest text-primary">
              Expert Tested & Updated
            </h3>
            <p className="font-sans text-sm text-muted-foreground mt-0.5">
              Every product is rigorously tested and our guides are updated monthly for accuracy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}